import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { ConfigReservations } from "../../types/generalTypes";
import { colors } from "../../constants/Colors";
import useIsMobile from "../../hooks/useIsMobile";

interface DefaultScheduleConfigProps {
  courtId: number;
  onApplyDefault: (configs: ConfigReservations[]) => void;
}

const DefaultScheduleConfig = ({
  courtId,
  onApplyDefault,
}: DefaultScheduleConfigProps) => {
  const isMobile = useIsMobile();

  const createDefaultConfig = () => {
    const defaultConfigs: ConfigReservations[] = [
      {
        day_of_week: 1,
        start_time: "13:00:00",
        end_time: "22:00:00",
        price: 80,
        court_id: courtId,
      },
      {
        day_of_week: 2,
        start_time: "13:00:00",
        end_time: "22:00:00",
        price: 80,
        court_id: courtId,
      },
      {
        day_of_week: 3,
        start_time: "13:00:00",
        end_time: "22:00:00",
        price: 80,
        court_id: courtId,
      },
      {
        day_of_week: 4,
        start_time: "13:00:00",
        end_time: "22:00:00",
        price: 80,
        court_id: courtId,
      },
      {
        day_of_week: 5,
        start_time: "13:00:00",
        end_time: "22:00:00",
        price: 80,
        court_id: courtId,
      },
      {
        day_of_week: 6,
        start_time: "13:00:00",
        end_time: "18:00:00",
        price: 100,
        court_id: courtId,
      },

      {
        day_of_week: 0,
        start_time: "13:00:00",
        end_time: "18:00:00",
        price: 120,
        court_id: courtId,
      },
    ];

    return defaultConfigs;
  };

  const handleApplyDefault = () => {
    const defaultConfigs = createDefaultConfig();
    onApplyDefault(defaultConfigs);
  };

  return (
    <Box
      sx={{
        marginBottom: isMobile ? "16px" : "20px",
        padding: isMobile ? "12px" : "16px",
        backgroundColor: "#f5f5f5",
        borderRadius: "8px",
      }}
    >
      <Typography
        sx={{
          fontSize: isMobile ? "13px" : "14px",
          color: "#666",
          marginBottom: isMobile ? "8px" : "12px",
        }}
      >
        Não tem certeza dos horários? Use nossa configuração padrão:
      </Typography>

      <Box sx={{ marginBottom: isMobile ? "8px" : "12px" }}>
        <Typography
          sx={{
            fontSize: isMobile ? "11px" : "12px",
            color: "#666",
            marginBottom: "4px",
          }}
        >
          <strong>Segunda a Sexta:</strong> 13:00 - 22:00 | R$ 80/hora
        </Typography>
        <Typography
          sx={{
            fontSize: isMobile ? "11px" : "12px",
            color: "#666",
            marginBottom: "4px",
          }}
        >
          <strong>Sábado:</strong> 13:00 - 18:00 | R$ 100/hora
        </Typography>
        <Typography
          sx={{
            fontSize: isMobile ? "11px" : "12px",
            color: "#666",
          }}
        >
          <strong>Domingo:</strong> 13:00 - 18:00 | R$ 120/hora
        </Typography>
      </Box>

      <Button
        variant="outlined"
        size="small"
        onClick={handleApplyDefault}
        fullWidth={isMobile}
        sx={{
          borderColor: colors.blue,
          color: colors.blue,
          "&:hover": {
            borderColor: colors.darkBlue,
            backgroundColor: "rgba(34, 111, 226, 0.04)",
          },
          fontWeight: 550,
          fontSize: isMobile ? "14px" : "12px",
          padding: isMobile ? "8px 16px" : "4px 8px",
        }}
      >
        Aplicar Configuração Padrão
      </Button>
    </Box>
  );
};

export default DefaultScheduleConfig;
